export default __webpack_public_path__ + "static/media/melania-profile.7f9c394a.jpg";